import {Permissions} from '@models/permissions.enum';
import {Component, inject} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {NgbAccordionConfig, NgbAccordionModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {CONTRACTS_LIST_ROUTE, CONTRACT_NEW_ROUTE} from '@shared/services/router/contract-routes';
import {ORGANISATIONS_LIST_ROUTE, ORGANISATION_NEW_ROUTE} from '@shared/services/router/organisation-routes';
import {PermissionPipe} from "@components/directives/permission.pipe";

@Component({
    selector: 'cdss-sidebar',
    standalone: true,
    imports: [NgbAccordionModule, NgbDropdownModule, RouterLink, RouterLinkActive, PermissionPipe],
    templateUrl: './cdss-sidebar.component.html',
    styleUrl: './cdss-sidebar.component.scss',
    providers: [NgbAccordionConfig],
})
export class CdssSidebarComponent {

    Permissions = Permissions;
    readonly contractsListRoute = '/' + CONTRACTS_LIST_ROUTE;
    readonly contractNewRoute = '/' + CONTRACT_NEW_ROUTE;
    readonly organisationsListRoute = '/' + ORGANISATIONS_LIST_ROUTE;
    readonly organisationNewRoute = '/' + ORGANISATION_NEW_ROUTE;
    private router = inject(Router);

    constructor(config: NgbAccordionConfig) {
        // customize default values of accordions used by this component tree
        config.closeOthers = true;
    }

    isSidebarOpen: boolean = false;

    toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
    }

    get isRegistrationActive(): boolean {
        const opts = {paths: 'subset' as const, queryParams: 'ignored' as const, matrixParams: 'ignored' as const, fragment: 'ignored' as const};
        return this.router.isActive('/cdss/patient-registration', opts)
            || this.router.isActive('/cdss/draft-patients', opts);
    }

    get isContractsActive(): boolean {
        const opts = {paths: 'subset' as const, queryParams: 'ignored' as const, matrixParams: 'ignored' as const, fragment: 'ignored' as const};
        return this.router.isActive(this.contractsListRoute, opts);
    }

    get isOrganisationsActive(): boolean {
        const opts = {paths: 'subset' as const, queryParams: 'ignored' as const, matrixParams: 'ignored' as const, fragment: 'ignored' as const};
        return this.router.isActive(this.organisationsListRoute, opts);
    }
}
